import React, { useRef } from "react";

import { Container, Row, Col } from "reactstrap";
import { Link, NavLink } from "react-router-dom";
import "../../styles/header.css";

const navLinks = [
  {
    path: "/home",
    display: "Home",
    icon: "ri-home-3-fill",
  },
  {
    path: "/about",
    display: "About",
    icon: "ri-file-info-line",
  },
  {
    path: "/services",
    display: "Services",
    icon: "ri-service-line",
  },
  {
    path: "/contact",
    display: "Contact",
    icon: "ri-phone-fill",
  },
];

const Header = () => {
  const menuRef = useRef(null);

  const toggleMenu = () => menuRef.current.classList.toggle("menu__active");

  return (
    <header className="header">
      {/* ============ header top ============ */}
      <div className="header__top">
        <div className="header__top__left">
          <span>Need Help?</span>
          <span className="header__top__help">
            <i class="ri-phone-fill"></i>
            <a href="tel:+254716650807">0716650807</a>
          </span>
        </div>
        <div className="header__top__right d-flex align-items-center justify-content-end gap-3">
          <Link to="#" className=" d-flex align-items-center gap-1">
            <i class="ri-login-circle-line"></i> Login
          </Link>

          <Link to="#" className=" d-flex align-items-center gap-1">
            <i class="ri-user-line"></i> Register
          </Link>
        </div>
      </div>

      <div className="middle_bottom">
        {/* =============== header middle =========== */}
        <div className="header__middle">
          <Col lg="4" md="3" sm="2">
            <div className="logo">
              <h1>
                <Link to="/home" className=" d-flex align-items-center gap-2">
                  <i class="ri-car-line"></i>
                  <span>Kim Cab</span>
                </Link>
              </h1>
            </div>
          </Col>

          <Col lg="3" md="3" sm="4">
            <div className="header__location d-flex align-items-center gap-2">
              <span>
                <i class="ri-earth-line"></i>
              </span>
              <div className="header__location-content">
                <h4>Kenya</h4>
                <h6>Nairobi City, Kenya</h6>
              </div>
            </div>
          </Col>

          <Col lg="3" md="3" sm="4">
            <div className="header__location d-flex align-items-center gap-2">
              <span>
                <i class="ri-time-line"></i>
              </span>
              <div className="header__location-content">
                <h4>Sunday to Friday</h4>
                <h6>10am - 7pm</h6>
              </div>
            </div>
          </Col>

          <Col
            lg="2"
            md="3"
            sm="0"
            className=" d-flex align-items-center justify-content-center "
          >
            <button className="header__btn btn ">
              <Link to="/contact">
                <i class="ri-phone-line"></i>Reach Out
              </Link>
            </button>
          </Col>
        </div>

        {/* ========== main navigation =========== */}

        <div className="main__navbar">
          <Container>
            <div className="navigation__wrapper d-flex align-items-center justify-content-between">
              <span className="mobile__menu">
                <i class="ri-menu-line" onClick={toggleMenu}></i>
              </span>

              <div className="navigation" ref={menuRef} onClick={toggleMenu}>
                <div className="menu">
                  {navLinks.map((item, index) => (
                    <NavLink
                      to={item.path}
                      className={(navClass) =>
                        navClass.isActive
                          ? "nav__active nav__item"
                          : "nav__item"
                      }
                      key={index}
                    >
                      <i class={item.icon} />
                      {item.display}
                    </NavLink>
                  ))}
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </header>
  );
};

export default Header;
